import { useMemo, useState } from "react"
import PropTypes from "prop-types"
import { OutlinedInput, IconButton, List, Paper, ClickAwayListener } from "@mui/material"
import classnames from "classnames"
import { map, size } from "lodash"
import { useGetQuery } from "hooks/queries"
import { useAccountAlias } from "resources/account"
import LegacySearchResult from "./result"
import LegacySearchStatusIcon from "./status-icon"
import { parseResults } from "./memoizers"
import "./style.scss"

export default function LegacySearch({ location, modelId }) {
  const account = useAccountAlias()

  const [open, setOpen] = useState(false)
  const [value, setValue] = useState("")

  const clear = () => {
    setOpen(false)
    setValue("")
  }

  const onKeyDown = event => {
    if (event.keyCode === 27) {
      // prevents clearing the field
      event.preventDefault()
      setOpen(false)
    } else {
      setOpen(true)
    }
  }

  const results = useGetQuery({
    url: `/api/${account}/m/${modelId}/securities/search?value=${encodeURIComponent(value)}`,
    enabled: value !== "",
  })

  const searchResults = useMemo(() => parseResults(results.status, results.data), [results.data, results.status])

  return <ClickAwayListener onClickAway={() => setOpen(false)}>
    <div className={classnames("components_legacy-search", { open })}>
      <div className="slider">
        <div className="mobile-pathname">{location}</div>
        <div className="search">
          <OutlinedInput
            value={value}
            onChange={(event) => setValue(event.target.value)}
            onKeyDown={onKeyDown}
            onFocus={() => setOpen(true)}
            type="search"
            size="small"
            placeholder="Search"
          />
        </div>
      </div>
      <IconButton className="search-icon-mobile" onClick={() => { setOpen(!open) }}>
        <LegacySearchStatusIcon status={results.fetchStatus} />
      </IconButton>
      <LegacySearchStatusIcon status={results.fetchStatus} className="search-icon" />
      {open && size(searchResults) > 0 && <Paper className="search-box results">
        <List>
          {map(searchResults, (result) => <LegacySearchResult key={result.id} clear={clear} {...result} />)}
        </List>
      </Paper>}
      {open && size(searchResults) === 0 && value !== "" && <Paper className="search-box results empty">
        No results...
      </Paper>}
    </div>
  </ClickAwayListener>
}

LegacySearch.propTypes = {
  location: PropTypes.string.isRequired,
  modelId: PropTypes.string.isRequired,
}
